import { Component, TemplateRef, ViewChild } from '@angular/core';
import { BaseDataSourceAbstract } from '@base/datalayer/BaseDataSourceAbstract';
import { DxListComponent } from 'devextreme-angular';
import { BottomSheetContext } from 'swipe-bottom-sheet/angular/BottomSheetContext';

@Component({
    selector: 'app-bottom-sheet-list',
    templateUrl: './bottom-sheet-list.component.html',
    styleUrls: ['./bottom-sheet-list.component.scss']
})
export class BottomSheetListComponent {
    DataSource: BaseDataSourceAbstract | any[];
    IsMultiSelection: boolean;
    ValueExpr: string;
    DisplayExpr: string;
    ListTemplate: TemplateRef<any>;
    @ViewChild('list') list: DxListComponent;

    constructor(private bottomSheetContext: BottomSheetContext<any>) {}

    OnItemClick(e) {
        if (this.IsMultiSelection) return;

        const selectedValue = e.itemData[this.ValueExpr];
        this.bottomSheetContext.dismiss(selectedValue);
    }

    ApplySelection() {
        this.bottomSheetContext.dismiss(this.list.selectedItemKeys);
    }
}
